import { useSelector } from 'react-redux';

import { ENTITY_PREFIX } from '../../../../../../constants';
import { formatEntityId } from '../../../../../../helpers';
import { FORTA_ERROR, FORTA_SUCCESS } from '../../../../../../utils/colors';
import {
  getPaDaysUntilExpiry,
  getPaExpiryIndicator,
  getPlanBayLabel,
  getPlanStatusIndicator,
} from '../utils';

import type { RootState } from '../../../../../../store';
import type { TreatmentPlanV3PageHeaderViewModel } from '../types';

export default function useTreatmentPlanV3PageHeader(): TreatmentPlanV3PageHeaderViewModel {
  const treatmentPlan = useSelector((state: RootState) => state.treatmentPlans.current);
  const tpStatusIdByLabel = useSelector(
    (state: RootState) => state.treatmentPlans.tpStatusIdByLabel,
  );
  const priorAuthorizations = useSelector(
    (state: RootState) => state.treatmentPlans.tpPriorAuthorizations,
  );
  const isPaLoading = useSelector(
    (state: RootState) =>
      state.treatmentPlans.tpPriorAuthorizationsLoading || state.treatmentPlans.currentTpLoading,
  );

  const paDays = isPaLoading ? null : getPaDaysUntilExpiry(priorAuthorizations, treatmentPlan?.id);

  return {
    planLabel:
      treatmentPlan?.id === undefined
        ? ''
        : formatEntityId(treatmentPlan.id, ENTITY_PREFIX.TreatmentPlan),
    authorName: [treatmentPlan?.provider?.first_name, treatmentPlan?.provider?.last_name]
      .filter(Boolean)
      .join(' '),
    status: getPlanStatusIndicator(treatmentPlan, tpStatusIdByLabel),
    activation: treatmentPlan?.is_active
      ? { label: 'Active', dotColor: FORTA_SUCCESS }
      : { label: 'Inactive', dotColor: FORTA_ERROR },
    bayLabel: getPlanBayLabel(treatmentPlan?.bay),
    paExpiry: getPaExpiryIndicator(paDays),
  };
}
